import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ButtonComponent } from '@en-voiture-simone/seemone/components/button';
import { TextComponent } from '@en-voiture-simone/seemone/components/text';

@Component({
  selector: 'evs-top-navigation',
  templateUrl: './top-navigation.component.html',
  styleUrls: ['./top-navigation.component.scss'],
  imports: [ButtonComponent, TextComponent],
})
export class TopNavigationComponent {
  @Input() title = '';
  @Input() backLabel = '';
  @Input() showBackButton = true;
  @Input() showCloseButton = false;
  @Input() backgroundColor: 'white' | 'colored' = 'white';
  @Input() isScrolling = false;
  @Input() isDesktop = false;
  @Input() stickyTitle = '';
  @Input() showProgressBar = false;
  @Input() progressValue = 0;
  @Input() progressTotal = 10;

  @Output() backClicked = new EventEmitter<void>();
  @Output() closeClicked = new EventEmitter<void>();

  onBackClick(): void {
    this.backClicked.emit();
  }

  onCloseClick(): void {
    this.closeClicked.emit();
  }

  getButtonIconColor(): string {
    // Icon color should be opposite of button background
    const buttonBg = this.getButtonBackgroundColor();
    // Both white and neutral-4 are light colors, so use black icon
    return 'black';
  }

  getButtonBackgroundColor(): string {
    if (this.isScrolling) return 'white';
    // Correct Figma: white page bg → neutral-4 buttons, colored page bg → white buttons
    return this.backgroundColor === 'white' ? 'neutral-4' : 'white';
  }

  getProgressSegments(): Array<{ filled: boolean }> {
    const segments = [];
    for (let i = 0; i < this.progressTotal; i++) {
      segments.push({ filled: i < this.progressValue });
    }
    return segments;
  }
}
